// Plain context object - kept in its own .ts file (no JSX, no
// component exports) so the matching ``UserProvider.tsx`` satisfies
// the ``react-refresh/only-export-components`` lint rule.
import { createContext } from "react";

import type { Role } from "./roles";

export interface UserContextValue {
  user: {
    email?: string | null;
    given_name?: string | null;
    family_name?: string | null;
  } | null;
  // Role granted by Kinde org membership; ``null`` until the
  // ``UserProvider`` gate confirms the user's org is recognised.
  // Children inside the provider can read this to render role-gated
  // UI - currently every recognised user is ``admin``, but future
  // orgs (e.g. ``landlord``, ``tenant``) will widen this union.
  role: Role | null;
  logout: (() => void) | null;
}

export const UserContext = createContext<UserContextValue>({
  user: null,
  role: null,
  logout: null,
});
